<template>
  <div class="step-section-2" style="padding-top: 20px">
    <!--    本科开始-->
    <el-col :span="10" :offset="1" class="step2-zy-container">
      <div class="step2-bk-lable">
        <el-button type="primary" size="small" plain>本科</el-button>
      </div>
      <div
        v-for="(item, index) in checkboxGroupBenke_xuqiu"
        :key="index"
        style="width: 90%; margin: 50px auto;"
      >
        <el-col
          :span="15"
          style="height: 32px; line-height: 32px; color: #606266;"
        >
          <div style="font-size: 13px">{{ item.zymc }}</div>
        </el-col>
        <el-col :span="8">
          <el-input-number
            v-model="item.need_num"
            :min="1"
            size="small"
            label="请输入需求人数"
          ></el-input-number>
        </el-col>
        <el-col
          :span="1"
          style="height: 32px; line-height: 32px; color: #606266;font-size: 15px"
        >
          <span style="font-size: 13px">人</span>
        </el-col>
      </div>
    </el-col>
    <!--    硕士开始-->
    <el-col :span="10" :offset="2" class="step2-zy-container" v-if="true">
      <div class="step2-ss-lable">
        <el-button type="primary" size="small" plain>硕士</el-button>
      </div>
      <div  style="width: 90%; margin: 50px auto">{{inputShuoshitextarea}}</div>
      <div
        v-for="(item1, index1) in checkboxGroupShuoshi_xuqiu"
        :key="index1"
        style="width: 90%; margin: 50px auto"
      >
        <el-col
          :span="15"
          style="height: 32px; line-height: 32px; color: #606266"
        >
          <span style="font-size: 13px">{{ item1.zymc }}</span>
        </el-col>
        <el-col :span="8">
          <el-input-number
            v-model="item1.need_num"
            :min="1"
            size="small"
            label="请输入需求人数"
          ></el-input-number>
        </el-col>
        <el-col
          :span="1"
          style="height: 32px; line-height: 32px; color: #606266"
        >
          <span style="font-size: 13px">人</span>
        </el-col>
      </div>
    </el-col>
  </div>
</template>

<script>
  export default {
    name: 'StepSection2',
    props: {
      stepTwoData: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        checkboxGroupBenke_xuqiu: [],
        checkboxGroupShuoshi_xuqiu: [],
        inputShuoshitextarea:'',
      }
    },
    mounted() {
      this.checkboxGroupBenke_xuqiu = this.stepTwoData.checkboxGroupBenke_xuqiu
      this.checkboxGroupShuoshi_xuqiu = this.stepTwoData.checkboxGroupShuoshi_xuqiu
      this.inputShuoshitextarea = this.stepTwoData.inputShuoshitextarea
    },
    methods: {},
  }
</script>

<style scoped>
  .step2-zy-container {
    height: 615px;
    border: 1px solid #409eff;
    border-radius: 8px;
    margin-bottom: 20px;
    margin-top: 20px;
    position: relative;
    overflow: scroll;
    z-index: 99;
  }
  .step2-bk-lable {
    position: absolute;
    left: 228px;
    top: 2px;
    z-index: 99999;
  }
  .step2-ss-lable {
    position: absolute;
    left: 228px;
    top: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/project/add-section/stepSection2.vue